if (Shopify.country === 'AU') {
  class FxGeoLocation extends HTMLElement {
    constructor() {
      super();
      // Initialize flags to determine visibility for Australian states/territories
      this.stateFlags = {
        'ACT': this.dataset.show_act === 'true',
        'NSW': this.dataset.show_nsw === 'true',
        'NT': this.dataset.show_nt === 'true',
        'QLD': this.dataset.show_qld === 'true',
        'SA': this.dataset.show_sa === 'true',
        'TAS': this.dataset.show_tas === 'true',
        'VIC': this.dataset.show_vic === 'true',
        'WA': this.dataset.show_wa === 'true',
      };
    }

    connectedCallback() {
      const raw = localStorage.getItem('GeoData');
      const geoData = raw ? JSON.parse(raw) : { country: '', region: '', time: 0 };
      if (geoData.region) {
        this.processGeoLocation(geoData.region);
      }

      window.addEventListener('GeoDataUpdated', (event) => {
        this.processGeoLocation(event.detail.region);
      });
    }

    processGeoLocation(data) {
      const shouldDisplay = this.stateFlags[data] || false;

      if (this.parentElement) {
        this.updateDisplay(shouldDisplay);
      } else {
        console.warn('parentElement is null, cannot apply classList manipulations.');
      }

      this.dispatchEvent(new CustomEvent('geoLocationProcessed', { bubbles: true, composed: true }));
    }

    updateDisplay(shouldDisplay) {
      const parentClasses = this.parentElement.classList;
      let activeClass;

      if (parentClasses.contains('slideshow')) {
        activeClass = 'activited-slide';
      } else if (parentClasses.contains('image--banner') || parentClasses.contains('banner-gallery-containner')) {
        activeClass = 'activited-image';

        if (!shouldDisplay && parentClasses.contains('image--banner')) {
          this.parentElement.parentElement.style.display = 'none';
        }
      }

      if (shouldDisplay) {
        this.style.display = 'contents';
        if (activeClass) this.classList.add(activeClass);
      } else {
        this.style.display = 'none';
        if (activeClass) this.classList.remove(activeClass);
      }
    }
  }

  // Define the custom element 'fx-geo-location'
  customElements.define('fx-geo-location', FxGeoLocation);
}
